import purchaseOffer from '@/components/purchase/purchase-offer/purchase-offer';

export default {
  mixins: [
    purchaseOffer,
  ],
  computed: {
    mainClassName() {
      return 'purchase-offer-desktop';
    },
    classModifiers() {
      return {
        [this.mainClassName]: true,
        [`${this.mainClassName}--${this.$router.currentRoute.name}`]: true,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/purchase-offer-desktop/purchase-offer-desktop.js